import React from 'react';
import styled from 'styled-components';
import colors from '../styles/colors';

const ColorsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  margin: 0;
  padding: 0.5rem 1.5rem 0.05rem 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  backdrop-filter: blur(10px);
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    gap: 1rem;
    padding: 0.4rem 1rem 0.02rem 1rem;
    margin: 0;
  }

  @media (max-width: 480px) {
    gap: 0.6rem;
    padding: 0.3rem 0.8rem 0.02rem 0.8rem;
    margin: 0;
  }

  @media (max-width: 360px) {
    gap: 0.4rem;
    padding: 0.25rem 0.6rem 0.02rem 0.6rem;
    margin: 0;
  }
`;

const ColorCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.color};
  border: 3px solid ${colors.neutral.lightGray};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  flex-shrink: 0;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    border: 2px solid ${colors.neutral.lightGray};
  }

  @media (max-width: 480px) {
    width: 26px;
    height: 26px;
    border: 1px solid ${colors.neutral.lightGray};
  }

  @media (max-width: 360px) {
    width: 22px;
    height: 22px;
    border: 1px solid ${colors.neutral.lightGray};
  }
`;

const ColorLabel = styled.span`
  font-size: 0.8rem;
  color: white;
  font-weight: 500;
  text-align: center;
  margin-top: 0.5rem;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 0.65rem;
    margin-top: 0.3rem;
  }

  @media (max-width: 480px) {
    font-size: 0.5rem;
    margin-top: 0.2rem;
  }

  @media (max-width: 360px) {
    font-size: 0.45rem;
    margin-top: 0.1rem;
  }
`;

const ColorItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`;

const UnionElement = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 1.5rem;
  height: 40px;
  width: 2px;
  background: ${colors.neutral.mediumGray};
  border-radius: 1px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin: 0 1rem;
    height: 32px;
    width: 1px;
  }

  @media (max-width: 480px) {
    margin: 0 0.6rem;
    height: 26px;
    width: 1px;
  }

  @media (max-width: 360px) {
    margin: 0 0.4rem;
    height: 22px;
    width: 1px;
  }
`;

const BrazilianColors = () => {
  const brazilColors = [
    { color: colors.primary.green, label: 'Verde' },
    { color: colors.primary.yellow, label: 'Amarelo' },
    { color: colors.primary.blue, label: 'Azul' }
  ];

  const italyColors = [
    { color: colors.italy.green, label: 'Verde' },
    { color: colors.italy.white, label: 'Branco' },
    { color: colors.italy.red, label: 'Vermelho' }
  ];

  return (
    <ColorsContainer>
      {brazilColors.map((item, index) => (
        <ColorItem key={`brazil-${index}`}>
          <ColorCircle color={item.color} />
          <ColorLabel>{item.label}</ColorLabel>
        </ColorItem>
      ))}
      
      <UnionElement />
      
      {italyColors.map((item, index) => (
        <ColorItem key={`italy-${index}`}>
          <ColorCircle color={item.color} />
          <ColorLabel>{item.label}</ColorLabel>
        </ColorItem>
      ))}
    </ColorsContainer>
  );
};

export default BrazilianColors;
